import React, { useEffect } from 'react'
import styles from './contact.module.css'
import { AboutOffice, BannerSec } from '../../components'
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigData } from '../../slice/configSlice';
import { fetchOfficesData } from '../../slice/officeSlice'

const Contact = () => {

    const dispatch = useDispatch();
    const {
        data: configData, loading, error

    } = useSelector((state) => state.config);
    const {
        office: { data: officeData },
    } = useSelector((state) => state);

    useEffect(() => {
        dispatch(fetchConfigData());
        dispatch(fetchOfficesData());
    }, [dispatch]);

    useEffect(() => {
        console.log(' Config Contact : ', configData)
    }, [configData, officeData]);


    return (
        <>
            <section className={styles.contactSec}>
                <BannerSec configData={configData} />
                <AboutOffice officeData={officeData} />
            </section>
        </>
    )
}

export default Contact
